// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent___brbV","modalForm":"UpgradeEpcsModal_modalForm__EH0Uk","modalFooter":"UpgradeEpcsModal_modalFooter__3rURe"};